import { Socket } from "phoenix";

export function initialisePhoenixWebsockets(app, user) {
  let socket = new Socket("/socket", {
    params: {
      user_token: user.token,
      organisation_id: user.organisationId,
      pms: user.pms,
      x_sandbox_id: window.sandboxId,
    },
  });

  socket.connect();

  announcementChannel(socket, app);
  organisationChannel(socket, app, user.organisationId);
  timesheetChannel(socket, app, user.id);
  pmsChannel(socket, app, user.pms);
}

function pmsChannel(socket, app, pms) {
  let pmsChannel = socket.channel("pms:" + pms);

  pmsChannel.join().receive("error", (resp) => {
    console.log("Unable to join PMS channel", resp);
  });

  pmsChannel.on("notification", (msg) => {
    app.ports.receiveNotification.send(msg);
  });
}

function announcementChannel(socket, app) {
  let announcementChannel = socket.channel("announcement", {});

  announcementChannel.join().receive("error", (resp) => {
    console.log("Unable to join announcement channel", resp);
  });

  announcementChannel.on("frontend_version", (msg) => {
    app.ports.frontendVersion.send(msg);
  });

  announcementChannel.on("announcement", (msg) => {
    app.ports.receiveAnnouncement.send(msg);
  });

  announcementChannel.on("notification", (msg) => {
    app.ports.receiveNotification.send(msg);
  });
}

function organisationChannel(socket, app, organisationId) {
  let organisationChannel = socket.channel("organisation:" + organisationId);

  organisationChannel.join().receive("error", (resp) => {
    console.log("Unable to join organisation channel", resp);
  });

  organisationChannel.on("matter_posted", (msg) => {
    app.ports.matterPosted.send(msg);
  });

  organisationChannel.on("notification", (msg) => {
    app.ports.receiveNotification.send(msg);
  });
}

function timesheetChannel(socket, app, userId) {
  let timesheetChannel = socket.channel("timesheet:" + userId);

  timesheetChannel.join().receive("error", (resp) => {
    console.log("Unable to join timesheet channel", resp);
  });

  timesheetChannel.on("fee_status_update", (msg) => {
    app.ports.feeStatusUpdate.send(msg);
  });

  timesheetChannel.on("fee_summary", (msg) => {
    app.ports.feeSummaryUpdate.send(msg);
  });

  timesheetChannel.on("fee_ai_completed", (msg) => {
    app.ports.feeAiCompleted.send(msg);
  });

  timesheetChannel.on("fee", (msg) => {
    app.ports.fee.send(msg);
  });

  timesheetChannel.on("fees", (msg) => {
    app.ports.fees.send(msg);
  });

  timesheetChannel.on("fee_created_and_select", (msg) => {
    app.ports.feeCreatedAndSelect.send(msg);
  });

  timesheetChannel.on("fee_with_running_timer", (msg) => {
    app.ports.feeWithRunningTimer.send(msg);
  });

  timesheetChannel.on("deleted_fees", (msg) => {
    app.ports.deletedFees.send(msg);
  });

  timesheetChannel.on("activity", (msg) => {
    app.ports.activity.send(msg);
  });

  timesheetChannel.on("activity_refresh", (msg) => {
    app.ports.activityRefresh.send(msg);
  });

  timesheetChannel.on("file_status", (msg) => {
    app.ports.feeFileStatusUpdate.send(msg);
  });

  timesheetChannel.on("file_status_update", (msg) => {
    app.ports.receiveFileStatusUpdate.send(msg);
  });

  timesheetChannel.on("remove_activities", (msg) => {
    app.ports.removeActivities.send(msg);
  });

  timesheetChannel.on("activities_deleted", (msg) => {
    app.ports.activitiesDeletedToast.send(msg);
  });

  timesheetChannel.on("fees_deleted_toast", (msg) => {
    app.ports.feesDeletedToast.send(msg);
  });

  timesheetChannel.on("update_exchange_status", (msg) => {
    app.ports.updateExchangeIntegrationStatus.send(msg);
  });

  timesheetChannel.on("update_pms_status", (msg) => {
    app.ports.updatePMSIntegrationStatus.send(msg);
  });

  timesheetChannel.on("update_phone_status", (msg) => {
    app.ports.updatePhoneIntegrationStatus.send(msg);
  });

  timesheetChannel.on("update_browser_extension_status", (msg) => {
    app.ports.updateBrowserExtensionIntegrationStatus.send(msg);
  });

  timesheetChannel.on("fee_ai_error_message", (msg) => {
    app.ports.receiveAiErrorMessage.send(msg);
  });

  timesheetChannel.on("flash_message", (msg) => {
    app.ports.receiveFlashMessage.send(msg);
  });
}
